export const ToolbarButtonGroupSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const TOOLBAR_BUTTON_GROUP_SIZES = Object.values(ToolbarButtonGroupSize);
